import { createCategoriesApi } from "@/v2/api/metadata/categories";
import { createSportsApi } from "@/v2/api/metadata/sports";
import { createTeamsApi } from "@/v2/api/metadata/teams";
import { createTournamentsApi } from "@/v2/api/metadata/tournaments";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createDialogs } from "./dialogs";
import { createFilters } from "./filters";

const LS_TEAMS_FILTERS_KEY = Symbol("teams-filters");

export function createTeamsView(ctx: BackofficeContext): EntityView {
  const teamsApi = createTeamsApi(ctx);
  const sportsApi = createSportsApi(ctx);
  const categoriesApi = createCategoriesApi(ctx);
  const tournamentsApi = createTournamentsApi(ctx);

  return {
    id: "teams",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi, categoriesApi, tournamentsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, teamsApi, sportsApi, categoriesApi, tournamentsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_TEAMS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: teamsApi.grid,
      },
    ],
  };
}
